// extracted by mini-css-extract-plugin
export default {"container":"Body_container__Me0k7","heading":"Body_heading__F1QX9","toolbar":"Body_toolbar__fwD62","main":"Body_main__S5mkq"};